import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../../Context/ConfigContext";
import axios from "axios";

const CompatibilityCars = ({ ART_ID, invalidPartMatch }) => {

    const { t } = useTranslation();
    const { gdcURL, setPopularModels } = useContext(ConfigContext);

    const [fitins, setFitIns] = useState({});
    const [loadingFitIn, setLoadingFitIn] = useState(true);
    const [showAll, setShowAll] = useState(false);

    const [openModels, setOpenModels] = useState({});

    useEffect(() => {

        const fetchFitIn = async () => {
            try {

                if (!ART_ID) return;

                let make = '';

                if (localStorage.getItem('car_info')) {
                    const car_info = JSON.parse(localStorage.getItem('car_info'));
                    make = car_info[0]?.MFA_BRAND || '';
                }

                setLoadingFitIn(true);

                const response = await axios.get(`${gdcURL}/Parts/GetPartFitIn`, {
                    params: {
                        lang: "en",
                        art_id: ART_ID,
                        make: make
                    }
                }
                );

                const data = response.data;

                let isInvalid = true;

                if (
                    localStorage.getItem('pc_id') &&
                    localStorage.getItem('pc_id') !== '0'
                ) {
                    for (let ii = 0; ii < data.data.length; ii++) {
                        if (data.data[ii].PC_ID === Number(localStorage.getItem('pc_id'))) {
                            isInvalid = false;
                            break;
                        }
                    }
                }

                invalidPartMatch(isInvalid);

                // ✅ BRAND → MODEL GROUPING
                const groupedData = data.data.reduce((acc, item) => {

                    const brand = item.MFA_BRAND;

                    if (!acc[brand]) {
                        acc[brand] = {};
                    }

                    const modelName = item.TYPEL.split("(")[0].trim();

                    if (!acc[brand][modelName]) {
                        acc[brand][modelName] = [];
                    }

                    const from = item.PCS_CI_FROM
                        ? item.PCS_CI_FROM.split('-')[0]
                        : '';

                    const to = item.PCS_CI_TO
                        ? item.PCS_CI_TO.split('-')[0]
                        : '2025';

                    acc[brand][modelName].push({
                        typel: item.TYPEL,
                        term: item.TERM_OF_USE,
                        from,
                        to
                    });

                    return acc;

                }, {});

                setFitIns(groupedData);

            } catch (error) {
                console.error('Error fetching fit ins:', error);
            } finally {
                setLoadingFitIn(false);
            }
        };

        fetchFitIn();

    }, [ART_ID, gdcURL]);


    useEffect(() => {
        if (fitins) {
            const allModels = [];

            Object.values(fitins).forEach(models => {
                allModels.push(...Object.keys(models));
            });

            setPopularModels([...new Set(allModels)]);
        }
    }, [fitins]);

    return (
        <>
            {
                Object.entries(fitins)?.length > 0 &&
                <div className="container">
                    <h4 style={{ lineHeight: 0 }}>
                        {t('compatibility_with_passenger_cars')}
                    </h4>

                    <div id="accordion1">
                        <div className="accordion" id="carAccordion">
                            {loadingFitIn ? (
                                <div></div>
                            ) : (
                                <>
                                    {Object.entries(fitins)
                                        .slice(0, showAll ? Object.keys(fitins).length : 3)
                                        .map(([brand, models], index) => (
                                            <div className="card card-accordion accordion-boxed" key={index}>

                                                {/* 🔹 SAME COLLAPSE HEADER (UNCHANGED) */}
                                                <a
                                                    className="card-header collapsed"
                                                    href="#"
                                                    data-toggle="collapse"
                                                    data-target={`#collapse${index}`}
                                                    aria-expanded="false"
                                                    aria-controls={`collapse${index}`}
                                                >
                                                    {brand}
                                                </a>

                                                {/* 🔹 SAME COLLAPSE BODY */}
                                                <div
                                                    id={`collapse${index}`}
                                                    className="collapse"
                                                    data-parent="#carAccordion"
                                                >
                                                    <div className="p-5" style={{ borderBottom: '#ddd 1px solid' }}>

                                                        {/* ✅ MODEL LOOP */}
                                                        {Object.entries(models).map(([modelName, variants], i) => {

                                                            const key = `${index}-${i}`;
                                                            const isOpen = openModels[key];

                                                            return (
                                                                <div key={i} style={{ marginBottom: "10px" }}>

                                                                    {/* ✅ MODEL HEADER + ICON */}
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            cursor: "pointer",
                                                                            fontWeight: "600"
                                                                        }}
                                                                        onClick={() =>
                                                                            setOpenModels(prev => ({
                                                                                ...prev,
                                                                                [key]: !prev[key]
                                                                            }))
                                                                        }
                                                                    >
                                                                        <span>{modelName}</span>
                                                                        <span>{isOpen ? "−" : "+"}</span>
                                                                    </div>

                                                                    {/* ✅ VARIANTS */}
                                                                    {isOpen && (
                                                                        <ul style={{ paddingLeft: "18px", marginTop: "5px" }}>
                                                                            {variants.map((model, modelIndex) => (
                                                                                <li key={modelIndex}>
                                                                                    {model.typel} {model.from} - {model.to}
                                                                                    {model.term && (
                                                                                        <span>
                                                                                            - ({t('term_of_use', { term: model.term })})
                                                                                        </span>
                                                                                    )}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}

                                                                </div>
                                                            );
                                                        })}

                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                    {/* SHOW MORE */}
                                    {fitins && Object.keys(fitins).length > 3 && (
                                        <div className="mt-2 text-center">
                                            {
                                                !showAll ?
                                                    <span
                                                        className="btn-link"
                                                        onClick={() => setShowAll(true)}
                                                        style={{ fontWeight: 'bold', cursor: 'pointer' }}
                                                    >
                                                        {t('show_more')}
                                                    </span>
                                                    :
                                                    <span
                                                        className="btn-link"
                                                        onClick={() => setShowAll(false)}
                                                        style={{ fontWeight: 'bold', cursor: 'pointer' }}
                                                    >
                                                        {t('show_less')}
                                                    </span>
                                            }
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default CompatibilityCars;